import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

import { IconComponent, IconName, IconSize, TruncateComponent } from '@recruitee/user-interface';

export type MainNavigationItemVariant = 'default' | 'kiwihr' | 'javelo';
@Component({
  selector: 'rt-main-navigation-item',
  templateUrl: './main-navigation-item.component.html',
  styleUrls: ['./main-navigation-item.component.less'],
  host: {
    '[class.active]': 'isActive',
    '[class.small]': 'size === "small"',
    '[class.circle]': '!buttonText',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TruncateComponent, IconComponent],
})
export class MainNavigationItemComponent {
  @Input() public isActive: boolean = false;
  @Input() public hoverEffect: boolean = false;
  @Input() public link: SafeUrl | string | null = null;
  @Input() public target: '_self' | '_blank' | null = '_blank';

  @Input() public icon: IconName;
  @Input() public iconSize: IconSize = 'small';
  @Input() public rightIcon: IconName | undefined;

  @Input() public buttonText: string | undefined;

  @Input() public size: 'small' | 'large' = 'large';

  @Input() public type: MainNavigationItemVariant = 'default';
}
